module.exports = __webpack_public_path__ + "img/d-biz.97252bc0.svg";